/** Normalize to start of minute (floor seconds/ms). */
export function normalizeRangeStart(date: Date): Date {
  const d = new Date(date);
  d.setSeconds(0, 0);
  return d;
}

/** Normalize to start of minute for inclusive end boundary. */
export function normalizeRangeEnd(date: Date): Date {
  const d = new Date(date);
  d.setSeconds(0, 0);
  return d;
}

/** Inclusive minute count — e.g. 14:00..14:30 = 31 steps. */
export function getMinuteCount(start: Date, end: Date): number {
  const startMs = normalizeRangeStart(start).getTime();
  const endMs = normalizeRangeEnd(end).getTime();
  if (endMs < startMs) return 0;
  return Math.floor((endMs - startMs) / 60_000) + 1;
}

export function getTimestampAtMinute(clockStart: Date, minuteOffset: number): Date {
  return new Date(clockStart.getTime() + minuteOffset * 60_000);
}

export function clampMinuteOffset(offset: number, minuteCount: number): number {
  if (minuteCount <= 0) return 0;
  return Math.max(0, Math.min(offset, minuteCount - 1));
}

export function getMinuteOffsetForTimestamp(
  clockStart: Date,
  timestamp: Date,
  minuteCount: number,
): number {
  const offset = Math.round((timestamp.getTime() - clockStart.getTime()) / 60_000);
  return clampMinuteOffset(offset, minuteCount);
}

export function getClosestMinuteOffsetToNow(clockStart: Date, minuteCount: number): number {
  if (minuteCount <= 0) return 0;
  const nowMs = Date.now();
  let closest = 0;
  let closestDiff = Infinity;
  for (let i = 0; i < minuteCount; i++) {
    const diff = Math.abs(getTimestampAtMinute(clockStart, i).getTime() - nowMs);
    if (diff < closestDiff) {
      closestDiff = diff;
      closest = i;
    }
  }
  return closest;
}
